module.exports = __webpack_public_path__ + "img/estufa_icon.2a920ee7.png";